import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MeterProvider } from '../../providers/meter/meter';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-consumption-chart',
  templateUrl: 'consumption-chart.html',
})
export class ConsumptionChartPage {

	public barChartOptions:any = {
	  scaleShowVerticalLines: false,
	  responsive: true,
	};
	public barChartLabels:string[] = [];
	public barChartType:string = 'horizontalBar';
	public barChartLegend:boolean = true;

  public barChartData:any[] = [];
  showData = false;

  selRegistrationLogin  : any;


  constructor(public navCtrl: NavController,private translate: TranslateService, public navParams: NavParams, public meterProvider: MeterProvider, private toast: ToastProvider) {
	this.selRegistrationLogin = localStorage.getItem('signup_login')

	if(this.selRegistrationLogin){
	  this.showData = true;
	  this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
	}
	else{
	
	meterProvider.getConsumption().then(val => {
      this.showData = true;
  		if(val.status == "success"){
  			let grid = [];
  			let dg = [];
  			let label =[];
  			val.data.forEach(val => {
  				label.push(this.getDate(val.time));
  				grid.push(val.grid);
  				dg.push(val.dg);
  			});
  			this.barChartLabels = label;
  			this.barChartData = [
				  {data: dg, label: 'DG'},
				  {data: grid, label: 'GRID'},
				];
  		}
	  });
	}
  }

  getDate(date: string){
    return (date.slice(6,8)+"-"+date.slice(4,6));
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConsumptionChartPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/consumption-chart/consumption-chart.ts